export const isDesktopView = () => {
	if ( window.matchMedia( '(min-width: 768px)' ).matches ) {
		return true;
	}

	return false;
};
